import {listViewSvg as Icon__small__listViewSvg} from '../Icon__small/Icon__small--listView.js'
import {listViewSvg as Icon__xsmall__listViewSvg} from '../Icon__xsmall/Icon__xsmall--listView.js'

export var listView = {
  name: 'listView',
  category: 'icon',
  colorable: true,
  svg: Icon__small__listViewSvg,
  alt: {
    Icon__small: Icon__small__listViewSvg,
    Icon__xsmall: Icon__xsmall__listViewSvg
  },
  combined: ['Icon__small', 'Icon__xsmall']
};
